import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface TooltipsState {
  enabled: boolean;
  setEnabled: (enabled: boolean) => void;
}

function applyToDOM(enabled: boolean) {
  if (enabled) {
    document.documentElement.removeAttribute('data-tooltips-disabled');
  } else {
    document.documentElement.setAttribute('data-tooltips-disabled', '');
  }
}

export const useTooltipsStore = create<TooltipsState>()(
  persist(
    (set) => ({
      enabled: true,
      setEnabled: (enabled: boolean) => {
        applyToDOM(enabled);
        set({ enabled });
      },
    }),
    {
      name: 'tooltips-storage',
      partialize: (state) => ({ enabled: state.enabled }),
      onRehydrateStorage: () => {
        return (state: TooltipsState | undefined) => {
          if (state) {
            applyToDOM(state.enabled);
          }
        };
      },
    }
  )
);
